import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { collection, collectionData, Firestore } from "@angular/fire/firestore";
import { ScheduleGame } from "../model/broadcast/game";

// Reads the per-league schedule that ball-score-server scrapes from WBSC into
// the `leagues/{leagueId}/scheduled-games` subcollection (one doc per game).
// Replaces the old WbscService.fetchScheduledGames proxy path.
@Injectable({
  providedIn: 'root'
})
export class SchedulesService {

  constructor(
    private firestore: Firestore,
  ) { }

  getSchedule(leagueId: string): Observable<ScheduleGame[]> {
    const ref = collection(this.firestore, `leagues/${leagueId}/scheduled-games`);
    return collectionData(ref) as Observable<ScheduleGame[]>;
  }
}
